import { ScopeableType } from '../../../types';
import { DiscountType } from '../../../utils/discount-utils';
import { ScopeItem } from '../../form-fields/scope-selector/scope-selector-constants';

export const DISCOUNT_CANCEL_BUTTON_TEST_ID = 'discount-cancel-button-test-id';
export const DISCOUNT_SUBMIT_BUTTON_TEST_ID = 'discount-submit-button-test-id';
export const DISCOUNT_START_DATE_PICKER_ID =
  'discount-start-date-picker-test-id';
export const DISCOUNT_END_DATE_PICKER_ID = 'discount-end-date-picker-test-id';

export interface DiscountFormValues {
  clientId: number;
  discountType: DiscountType;
  startDate: Date;
  endDate: Date | null;
  discount: string | number;
  suppressEmptyCharges: boolean;
  scopeableType: ScopeableType;
  scopes: ScopeItem[];
}

export interface ParsedDiscountValues {
  clientId: number;
  discount: number;
  discountType: string;
  startDate: string;
  endDate: string | null;
  suppressEmptyCharges: boolean;
  scopes: ScopeItem[];
}
